import React from 'react';
import useTranslation from '../../../hooks/translation-hook';
import MissionIntroductionPopup from './MissionIntroductionPopup';

const RemoteMissionsPopup = ({ onClose }: { onClose(dontShowAgain?: boolean): void }) => {
  const t = useTranslation();
  return (
    <MissionIntroductionPopup
      title={t('remote-missions-intro-title')}
      tagline={t('remote-missions-intro-tagline')}
      body={t('remote-missions-intro-body')}
      onClose={onClose}
    />
  );
};

export default RemoteMissionsPopup;
